// Events — Firestore service
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './config';

const COL = 'events';

/** Fetch all events ordered by event date */
export async function fetchEvents() {
  const q = query(collection(db, COL), orderBy('date', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

/** Add a new event (admin only) */
export async function addEvent(data) {
  const ref = await addDoc(collection(db, COL), {
    ...data,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

/** Delete an event (admin only) */
export async function deleteEvent(id) {
  await deleteDoc(doc(db, COL, id));
}
